import { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { constants } from "~/utils/constants";
import { Device } from "@capacitor/device";

export default function AppVersionBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");

  useEffect(() => {
    async function checkVersion() {
      try {
        const deviceInfo = await Device.getInfo()
        if (deviceInfo.platform !== 'android' && deviceInfo.platform !== 'ios') return;

        const info = await App.getInfo();
        const installedVersionCode = Number(info.build);

        const latest = constants.APP_VERSION_URL[deviceInfo.platform]

        if (installedVersionCode < latest.latestVersionCode) {
          setShowBanner(true);
          setDownloadUrl(latest.downloadUrl);

          setTimeout(() => {
            setShowBanner(false);
          }, 8000);
        }
      } catch (err) {
        console.error("Version check failed", err);
      }
    }

    checkVersion();
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-9999 bg-red-200 p-3 text-center">
    🚨 You’re using an old version of the app.
    <br />
    Please uninstall and install the latest app 👉{" "}
    <a
      href={downloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold text-blue-600 underline hover:text-blue-800"
    >
      Download
    </a>
  </div>
  );
}
